import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { registerLicense } from '@syncfusion/ej2-base';
import { LogLevel, setLogLevel } from '@angular/fire';

import { environment } from '../../commondata/environments/environment';
import { initializeApp, getApps } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

registerLicense('Ngo9BigBOggjHTQxAR8/V1NNaF5cXmBCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdmWXtfdHVVQ2hcUUBxWUJWYEo=');

setLogLevel(LogLevel.SILENT);

if (getApps().length === 0) {
  const app = initializeApp(environment.configFirebase);
  // Questo assicura che l'istanza [DEFAULT] esista globalmente prima di Angular
  getFirestore(app);
}

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
